import { render, staticRenderFns } from "./StonyTomb.vue?vue&type=template&id=4fbb5e41"
import script from "./StonyTomb.vue?vue&type=script&lang=js"
export * from "./StonyTomb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports